import { createAction } from 'typesafe-actions';
import { TiktokUserInfo, TiktokPost } from '@lib/domain/tiktok';
import { createActionTypePrefixFormat } from '../common';
import { TiktokOverviewOrder, TiktokCompleteOrder } from '../Titkok/types';

const typePrefixFormat = createActionTypePrefixFormat('Tiktok');

/* ------------- action creators ------------- */
export const setTiktokUser = createAction(
    typePrefixFormat('SET_TIKTOK_USER'),
    (user: TiktokUserInfo) => ({
        user,
    }),
)();

export const setTiktokPosts = createAction(
    typePrefixFormat('SET_TIKTOK_POSTS'),
    (posts: TiktokPost[]) => ({
        posts,
    }),
)();

export const setTiktokOverviewOrder = createAction(
    typePrefixFormat('SET_TIKTOK_OVERVIEW_ORDER'),
    (order: TiktokOverviewOrder) => ({
        order,
    }),
)();

export const setTiktokCompleteOrder = createAction(
    typePrefixFormat('SET_TIKTOK_COMPLETE_ORDER'),
    (order: TiktokCompleteOrder) => ({
        order,
    }),
)();

export const setTiktokCursorPost = createAction(
    typePrefixFormat('SET_TIKTOK_LOAD_MORE'),
    (cursor: string | undefined) => ({
        cursor,
    }),
)();
export const resetTiktokData = createAction(
    typePrefixFormat('RESET_TIKTOK_DATA'),
    () => null,
)();

export type TiktokActions = ReturnType<
    | typeof setTiktokUser
    | typeof setTiktokPosts
    | typeof setTiktokOverviewOrder
    | typeof setTiktokCompleteOrder
    | typeof setTiktokCursorPost
    | typeof resetTiktokData
>;
